export const dataLibT = [{
  word: 'tifi',
  partOfSpeech: 'N',
  definition: ['young girl', 'young lady'],
  egSentenceKw: 'Sa ki tifi sala?',
  egSentenceEn: 'Who is that girl?',
  synonym: ['kabwès'],
  antonym: [null],
  etymology: '[< Fr. petit fille]',
  dialect: '🇱🇨',
  variant: [null],
}, {
  word: 'tab',
  partOfSpeech: 'N',
  definition: ['table'],
  egSentenceKw: 'Yo mété kouto-a asou tab-la.',
  egSentenceEn: 'They put the knife on the table.',
  synonym: [null],
  antonym: [null],
  etymology: '[< Fr. table]',
  dialect: '🇱🇨',
  variant: [null],
}, {
  word: 'tjè',
  partOfSpeech: 'N',
  definition: ['heart'],
  egSentenceKw: 'Madanm sala malad an tjè\'y.',
  egSentenceEn: 'That woman has a problem with her heart.',
  synonym: [null],
  antonym: [null],
  etymology: '[< Fr. cœur]',
  dialect: '🇱🇨',
  variant: [null],
}, {
  word: 'tjilòt',
  partOfSpeech: 'N',
  definition: ['pants'],
  egSentenceKw: 'Mwen té ka pòté tjilòt nwè.',
  egSentenceEn: 'I was wearing black pants.',
  synonym: [null],
  antonym: [null],
  etymology: '[< Fr. culotte]',
  dialect: '🇱🇨',
  variant: [null],
}, {
  word: 'té',
  partOfSpeech: 'ADV',
  definition: ['anterior verb marker'],
  egSentenceKw: 'I té vini plas sala an chay tan ki pasé.',
  egSentenceEn: 'He had come to that place a long time ago.',
  synonym: [null],
  antonym: [null],
  etymology: null,
  dialect: '🇱🇨',
  variant: 'sété',
}, {
  word: 'tonton',
  partOfSpeech: 'N',
  definition: ['uncle'],
  egSentenceKw: 'Tonton mwen sé on chapantyé.',
  egSentenceEn: 'My uncle is a carpenter.',
  synonym: [null],
  antonym: [null],
  etymology: '[< Fr. oncle]',
  dialect: '🇱🇨',
  variant: [null],
}, {
  word: 'tantant',
  partOfSpeech: 'N',
  definition: ['aunt'],
  egSentenceKw: 'Nou té ka wété épi tantant nou.',
  egSentenceEn: 'We used to live with our aunt.',
  synonym: [null],
  antonym: [null],
  etymology: '[< Fr. tante]',
  dialect: '🇱🇨',
  variant: [null],
}, {
  word: 'tig',
  partOfSpeech: 'N',
  definition: ['tiger'],
  egSentenceKw: 'Jik toujou tig ka wété an bwa-a.',
  egSentenceEn: 'To this day tigers live in the woods.',
  synonym: ['chat tig'],
  antonym: [null],
  etymology: '[< Fr. tigre]',
  dialect: '🇱🇨',
  variant: [null],
}, {
  word: 'tibway',
  partOfSpeech: 'N',
  definition: ['boy', 'son'],
  egSentenceKw: 'Konmen tibway ou ni?',
  egSentenceEn: 'How many boys do you have?',
  synonym: ['gason'],
  antonym: [null],
  etymology: null,
  dialect: '🇱🇨',
  variant: [null],
}, {
  word: 'taks',
  partOfSpeech: 'N',
  definition: ['tax'],
  egSentenceKw: 'Mwen ka péyé taks toulé mwa.',
  egSentenceEn: 'I pay taxes every month.',
  synonym: [null],
  antonym: [null],
  etymology: '[< Eng. tax]',
  dialect: '🇱🇨',
  variant: [null],
}, {
  word: 'twavay',
  partOfSpeech: 'V',
  definition: ['to work'],
  egSentenceKw: 'I ka twavay wèd bay lizin-an.',
  egSentenceEn: 'He works hard for the factory.',
  synonym: ['djòb'],
  antonym: [null],
  etymology: '[< Fr. travailler, Fr.travail]',
  dialect: '🇱🇨',
  variant: ['twimé'],
}, {
  word: 'twavay',
  partOfSpeech: 'N',
  definition: ['work', 'job'],
  egSentenceKw: 'La pa ni djè twavay isi.',
  egSentenceEn: 'There\'s scarcely any work here.',
  synonym: ['djòb'],
  antonym: [null],
  etymology: '[< Fr. travailler, Fr.travail]',
  dialect: '🇱🇨',
  variant: [null],
}, {
  word: 'tanmadòz',
  partOfSpeech: 'N',
  definition: ['tomatoes'],
  egSentenceKw: 'Nou alé an jaden-an pou tjouyi tanmadòz.',
  egSentenceEn: 'We went to the garden to pick tomatoes.',
  synonym: [null],
  antonym: [null],
  etymology: '[< Eng. tomatoes]',
  dialect: '🇱🇨',
  variant: [null],
}, {
  word: 'taya',
  partOfSpeech: 'N',
  definition: ['tire'],
  egSentenceKw: 'Taya-a pété; sé sa ki fè vann-an maté-a.',
  egSentenceEn: 'The tire blew; that is what made the van overturn.',
  synonym: [null],
  antonym: [null],
  etymology: '[< Eng. tire]',
  dialect: '🇱🇨',
  variant: [null],
}, {
  word: 'tép',
  partOfSpeech: 'N',
  definition: ['tape measure'],
  egSentenceKw: 'Chapantyé-a pèd tép li.',
  egSentenceEn: 'The carpenter lost his tape measure.',
  synonym: [null],
  antonym: [null],
  etymology: '[< Eng. tape]',
  dialect: '🇱🇨',
  variant: [null],
}, {
  word: 'tim',
  partOfSpeech: 'N',
  definition: ['team'],
  egSentenceKw: 'I ka jwé bay an lòt tim.',
  egSentenceEn: 'He is playing for another team.',
  synonym: [null],
  antonym: [null],
  etymology: '[< Eng. team]',
  dialect: '🇱🇨',
  variant: [null],
}, {
  word: 'tin',
  partOfSpeech: 'N',
  definition: ['tin', 'small can'],
  egSentenceKw: 'I genyen on tin lèt.',
  egSentenceEn: 'He bought a can of milk.',
  synonym: [null],
  antonym: [null],
  etymology: '[< Eng. tin]',
  dialect: '🇱🇨',
  variant: [null],
}, {
  word: 'titj',
  partOfSpeech: 'V',
  definition: ['to teach'],
  egSentenceKw: 'Misyé-a ka titj an lékòl-la.',
  egSentenceEn: 'The man teaches in the school.',
  synonym: ['enstwi'],
  antonym: [null],
  etymology: '[< Eng. teach]',
  dialect: '🇱🇨',
  variant: [null],
}, {
  word: 'titja',
  partOfSpeech: 'V',
  definition: ['teacher'],
  egSentenceKw: 'Lékòl-la pa ni asé titja.',
  egSentenceEn: 'The school doesn\'t have enough teachers.',
  synonym: [null],
  antonym: [null],
  etymology: '[< Eng. teacher]',
  dialect: '🇱🇨',
  variant: [null],
}, {
  word: 'tiyéta',
  partOfSpeech: 'N',
  definition: ['movie cinema'],
  egSentenceKw: 'I té vlé fè on tiyéta.',
  egSentenceEn: 'He wanted to make a cinema.',
  synonym: [null],
  antonym: [null],
  etymology: '[< Eng. theatre]',
  dialect: '🇱🇨',
  variant: [null],
}, {
  word: 'tjiki',
  partOfSpeech: 'ADJ',
  definition: ['nosy', 'prying', 'unduly curious'],
  egSentenceKw: 'Gason-an tjiki an chay.',
  egSentenceEn: 'The boy is very inquisitive.',
  synonym: [null],
  antonym: [null],
  etymology: '[< Eng. cheeky]',
  dialect: '🇱🇨',
  variant: [null],
}, {
  word: 'tjok',
  partOfSpeech: 'ADJ',
  definition: ['clogged', 'plugged'],
  egSentenceKw: 'Sitenn-an tjok.',
  egSentenceEn: 'The pipe is clogged.',
  synonym: ['bouché'],
  antonym: [null],
  etymology: '[< Eng. choked]',
  dialect: '🇱🇨',
  variant: [null],
}, {
  word: 'tjòkanblòk',
  partOfSpeech: 'ADJ',
  definition: ['haphazardly', 'chockablock'],
  egSentenceKw: 'I mété sé liv-la tjòkanblòk.',
  egSentenceEn: 'He put the books in haphazardly.',
  synonym: [null],
  antonym: [null],
  etymology: '[< Eng. chockablock]',
  dialect: '🇱🇨',
  variant: [null],
}, {
  word: 'tou',
  partOfSpeech: 'ADV',
  definition: ['also', 'as well', 'too'],
  egSentenceKw: 'Nou vlé alé tou.',
  egSentenceEn: 'We want to go too.',
  synonym: ['osi'],
  antonym: [null],
  etymology: '[< Eng. too]',
  dialect: '🇱🇨',
  variant: [null],
}, {
  word: 'trakta',
  partOfSpeech: 'N',
  definition: ['tractor'],
  egSentenceKw: 'Tan lontan yo pa té ni trakta.',
  egSentenceEn: 'Long ago they didn\'t have tractors.',
  synonym: [null],
  antonym: [null],
  etymology: '[< Eng. tractor]',
  dialect: '🇱🇨',
  variant: [null],
}, {
  word: 'tròk',
  partOfSpeech: 'N',
  definition: ['bus', 'truck'],
  egSentenceKw: 'Tròk-la ka maché byen.',
  egSentenceEn: 'The truck runs well.',
  synonym: ['machin'],
  antonym: [null],
  etymology: '[< Eng. truck]',
  dialect: '🇱🇨',
  variant: [null],
}, {
  word: 'tann',
  partOfSpeech: 'V',
  definition: ['to hear'],
  egSentenceKw: 'M\'a tann sa ou di-a.',
  egSentenceEn: 'I didn\'t hear what you said.',
  synonym: ['kouté'],
  antonym: [null],
  etymology: '[< Fr. entendre]',
  dialect: '🇱🇨',
  variant: [null],
}, {
  word: 'tout',
  partOfSpeech: 'ADJ',
  definition: ['all'],
  egSentenceKw: 'Vini denmen èk mennen tout sé liv-la.',
  egSentenceEn: 'Come tomorrow and bring all the books.',
  synonym: ['dènyé'],
  antonym: ['pyès'],
  etymology: '[< Fr. tout]',
  dialect: '🇱🇨',
  variant: [null],
}, {
  word: 'tout',
  partOfSpeech: 'ADJ',
  definition: ['every'],
  egSentenceKw: 'Kolonm sala ni pou gadé tout détay avan i sa di twavay-la bon.',
  egSentenceEn: 'That foreman has to look at every detail before he can say the work is good.',
  synonym: ['dènyé'],
  antonym: ['pyès'],
  etymology: '[< Fr. tout]',
  dialect: '🇱🇨',
  variant: [null],
}, {
  word: 'toutwèl',
  partOfSpeech: 'N',
  definition: ['Zenaida dove', '(Zenaida aurita)'],
  egSentenceKw: null,
  egSentenceEn: null,
  synonym: [null],
  antonym: [null],
  etymology: null,
  dialect: '🇱🇨',
  variant: [null],
}, {
  word: 'twanblè',
  partOfSpeech: 'N',
  definition: ['trembler: a type of bird that trembles'],
  egSentenceKw: 'Twanblè sé on jibyé ki ni an lonng bèk.',
  egSentenceEn: 'The trembler is a bird with a long beak.',
  synonym: [null],
  antonym: [null],
  etymology: '[< Fr. trembleur]',
  dialect: '🇱🇨',
  variant: [null],
}, {
  word: 'ti',
  partOfSpeech: 'ADV',
  definition: ['yes'],
  egSentenceKw: 'Joel? Ti, manm.',
  egSentenceEn: 'Joel? Yes, mother.',
  synonym: [null],
  antonym: [null],
  etymology: null,
  dialect: '🇱🇨',
  variant: [null],
}, {
  word: 'té',
  partOfSpeech: 'ADV',
  definition: ['anterior verb marker'],
  egSentenceKw: 'I té vini plas sala an chay tan ki pasé.',
  egSentenceEn: 'He had come to that place a long time ago.',
  synonym: [null],
  antonym: [null],
  etymology: null,
  dialect: '🇱🇨',
  variant: ['sété'],
}, {
  word: 'toujou',
  partOfSpeech: 'ADV',
  definition: ['still', 'yet'],
  egSentenceKw: 'I ka palé toujou.',
  egSentenceEn: 'He is speaking still.',
  synonym: ['konstanman', 'tout lè', 'tout tan'],
  antonym: ['janmen'],
  etymology: null,
  dialect: '🇱🇨',
  variant: [null],
}, {
  word: 'tan',
  partOfSpeech: 'N',
  definition: ['time'],
  egSentenceKw: 'La ni on tan pou tout bagay.',
  egSentenceEn: 'There is a time for everything.',
  synonym: [null],
  antonym: [null],
  etymology: '[< Fr. temp]',
  dialect: '🇱🇨',
  variant: [null],
}, {
  word: 'tan',
  partOfSpeech: 'N',
  definition: ['weather'],
  egSentenceKw: 'Tan-an mové jòdi-a.',
  egSentenceEn: 'The weather is bad today.',
  synonym: [null],
  antonym: [null],
  etymology: '[< Fr. temps]',
  dialect: '🇱🇨',
  variant: [null],
}, {
  word: 'tan',
  partOfSpeech: 'ADJ',
  definition: ['Such and such an amount (deliberately vague)'],
  egSentenceKw: 'Ès sé pou tan lajan ou vann tè sala?',
  egSentenceEn: 'Is it for such and such an amount you sold the land?',
  synonym: [null],
  antonym: [null],
  etymology: null,
  dialect: '🇱🇨',
  variant: [null],
}, {
  word: 'toulé',
  partOfSpeech: 'ADJ',
  definition: ['Every)'],
  egSentenceKw: 'Nou ka mouté toulé bonmatan.',
  egSentenceEn: 'We go up every morning.',
  synonym: [null],
  antonym: [null],
  etymology: '[< Fr. tous les]',
  dialect: '🇱🇨',
  variant: ['toulèz'],
}, {
  word: 'toulé',
  partOfSpeech: 'ADJ',
  definition: ['Both'],
  egSentenceKw: 'Ban mwen toulé dé pil zowanj-lan.',
  egSentenceEn: 'Give me both piles of oranges.',
  synonym: [null],
  antonym: [null],
  etymology: '[< Fr. tous les]',
  dialect: '🇱🇨',
  variant: ['toulèz'],
}, {
  word: 'toulé',
  partOfSpeech: 'ADJ',
  definition: ['Every other'],
  egSentenceKw: 'Nou kz vizitè toulé dé simenn.',
  egSentenceEn: 'We visit every other week.',
  synonym: [null],
  antonym: [null],
  etymology: '[< Fr. tous les]',
  dialect: '🇱🇨',
  variant: ['toulèz'],
}, {
  word: 'tèt',
  partOfSpeech: 'N',
  definition: ['head'],
  egSentenceKw: 'I ka pòté on patjé bwa asou tèt li.',
  egSentenceEn: 'She is carrying a bundle of wood on her head.',
  synonym: [null],
  antonym: [null],
  etymology: '[< Fr. tête]',
  dialect: '🇱🇨',
  variant: [null],
},
];
